module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[70]191.88788c6.woff2";